<div class="button" [ngStyle]="style">
  <button mat-raised-button (click)="onClick()">
    <span>{{ content.text }}</span>
    <shared-svg-icon class="icon" icon="button-arrow"></shared-svg-icon>
  </button>
</div>